import axios from "axios";
import authHeader from "./auth-header";

class LogService {
  getLogs(type = "user") {
    return axios.get(process.env.REACT_APP_API_URL + "logs/" + type, {
      headers: authHeader(),
    });
  }
}

export default new LogService();
